import axios from 'axios';

function authenticatedConfig() {
  const token = localStorage.getItem('token');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

export async function getNewsContext(ticker, eventType = 'detalhe do ativo') {
  const response = await axios.get(`/api/news-context/${encodeURIComponent(ticker)}`, {
    ...authenticatedConfig(),
    params: { eventType },
  });
  return response.data;
}